
<template>
	<div class="container mx-auto flex flex-col items-center justify-center my-8 bg-white py-8 rounded-lg">
		<div class="w-full max-w-2xl overflow-x-auto text-grayDark">
			<form @submit.prevent="submitCreateTeam" class="overflow-y-auto px-6 flex gap-4">
				<label class="mt-2 block text-[14px] font-medium text-gray-700">Choose a Project</label>
				<div class="">
					<div class="space-y-8 mb-6">
						<div class="flex flex-col gap-2">
							<CustomSelect :options="projects" v-model="selectedProject" labelKey="project_name" valueKey="project_id"
								placeholder="Select a project" />
							<div v-if="projectLoading" class="text-blue-500 text-sm mt-1">Loading projects...</div>
							<div v-if="projectError" class="text-red-500 text-sm mt-1">{{ projectError }}</div>
						</div>
						<div class="flex flex-col gap-2">
							<label class="block text-[14px] font-medium text-gray-700">Team Name</label>
							<input v-model="teamName" type="text" placeholder="Enter team name"
								class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
								required />
						</div>
						<div class="flex flex-col gap-2">
							<label class="block text-[14px] font-medium text-gray-700">Description</label>
							<textarea v-model="description" placeholder="Enter description"
								class="mt-1 block w-full h-[100px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
								required>
							</textarea>
						</div>
						<div class="flex flex-col gap-2">
							<label class="block text-[14px] font-medium text-gray-700">Add Members via CSV (Optional)</label>
							<input type="file" accept=".csv" @change="handleFileUpload"
								class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" />
							<div v-if="memberEmails.length > 0" class="text-sm text-green-600 mt-1">
								Found {{ memberEmails.length }} valid emails.
							</div>
						</div>
					</div>

					<div class="flex justify-end mt-10 text-[14px]">
						<button type="button" class="mr-4 py-2 px-4 border border-grayLight text-grayDark rounded"
							@click="resetForm">
							Cancel
						</button>
						<button type="submit" class="mr-4 py-2 px-4 bg-primaryDark text-primaryLight rounded">
							Save
						</button>
						<button type="submit" class="flex items-center gap-2 py-2 px-6 bg-primaryDarkBg h-[42px] text-white rounded"
							:disabled="submitDisabled">
							Save & Move to Next
						</button>
					</div>
				</div>

			</form>
		</div>
	</div>
</template>

<script>
import apiClient from '@/axios';
import CustomSelect from './CustomSelect.vue';

export default {
	name: 'CreateTeam',
	components: {
		CustomSelect
	},
	props: {
		projects: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			selectedProject: null,
			teamName: '',
			description: '',
			members: [],
			memberEmails: [],
			projectLoading: false,
			projectError: null,
			localProjects: []
		}
	},
	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
		isManager() {
			return this.$store.getters.isManager;
		},
		submitDisabled() {
			return !this.selectedProject || !this.teamName || this.projectLoading;
		},
		displayProjects() {
			return this.projects.length > 0 ? this.projects : this.localProjects;
		}
	},
	methods: {
		async submitCreateTeam() {
			this.showError = false;
			this.errorMessage = '';
			try {

				if (!this.selectedProject || !this.teamName) {
					alert("Please fill all required fields");
					return;
				}


				this.teamData = {
					project_id: this.selectedProject,
					name: this.teamName,
					description: this.description,
					members: [],
					member_emails: this.memberEmails
				};
				const response = await apiClient.post('/web/teams/', this.teamData);
				console.log('team created:', response.data);

				this.showSuccess = true;
				this.successMessage = 'team created successfully!';
				this.$emit('team-created', response.data.data);
				this.teamName = '';
				this.description = '';
			} catch (error) {
				console.error('Error creating team:', error);
				this.showError = true;
				this.errorMessage = error.response?.data?.message || 'An error occurred';
				this.$emit('error', this.errorMessage);

			}
		},
		resetForm() {
			this.teamName = '';
			this.selectedProject = null
			this.teamName = ''
			this.description = ''
			this.memberEmails = []
		},
		async handleFileUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			const reader = new FileReader();
			reader.onload = (e) => {
				const text = e.target.result;
				const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
				const matches = text.match(emailRegex) || [];
				this.memberEmails = [...new Set(matches)];
			};
			reader.readAsText(file);
		},
		async loadInitialData() {
			if (!this.projects || this.projects.length === 0) {
				try {
					this.projectLoading = true;
					this.projectError = null;
					console.log('Fetching projects...');

					let response;
					if (this.isManager) {
						response = await apiClient.get('/web/manager/me');
						const managerData = response.data.data;
						this.localProjects = managerData.projects || [];
					} else if (this.isAdmin) {
						response = await apiClient.get('/web/projects_all');
						this.localProjects = response.data.data || [];
					} else {
						response = await apiClient.get('/web/talent/me');
						const talentData = response.data.data;
						this.localProjects = talentData.projects || [];
					}

					console.log(`Loaded ${this.localProjects.length} projects:`, this.localProjects);
				} catch (error) {
					console.error('Error fetching projects:', error);
					this.projectError = error.response?.data?.message || 'Failed to load projects';
				} finally {
					this.projectLoading = false;
				}
			}
		}
	},
	created() {
		this.loadInitialData();
	}
};
</script>
